import React, { createContext, useState } from "react";

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [schema, setSchema] = useState(null);

  const resetChat = () => {
    setMessages([]);
    setSchema(null); 
  };

  const addMessage = (msg) => setMessages((prev) => [...prev, msg]);

  return (
    <ChatContext.Provider
      value={{
        messages,
        setMessages, // Exposed setter for AppRoutes to load conversations
        addMessage,
        resetChat,
        schema,
        setSchema,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};